// extracted by mini-css-extract-plugin
export default {"copyBtn":"uIkNJ","otp":"mZEYn","popover":"xO_oC","hidePopover":"OkdeC"};